import { useQuery } from '@tanstack/react-query';

import { api } from './api';

/** Katalog publik (paket, tier, metode) jarang berubah: cache 5 menit. */
export function useCatalog() {
  return useQuery({ queryKey: ['catalog'], queryFn: () => api('catalog'), staleTime: 5 * 60_000 });
}

/** Hanya pohon Shopper aktif yang bisa naik kelas, dan hanya bila setting mengizinkan (PRD bagian 6). */
export function canUpgrade(
  tree: { classCode: string; status: string },
  allowed: boolean | undefined,
): boolean {
  return tree.classCode === 'SHOPPER' && tree.status === 'ACTIVE' && allowed === true;
}
